import './circularProgressFullScreen.css';

import CircularProgress from '@mui/material/CircularProgress';

import { locator } from '../../testing/e2e-locator/locator';

export const CircularProgressFullScreen = () => {
  return (
    <div
      className="fullscreen-container"
      data-testid={locator.components.circularProgressFullScreen.root}
    >
      <CircularProgress />
    </div>
  );
};
